export default "__VITE_ASSET__BInD8X0s__"